import { Select } from 'components/Select';
import { Option } from 'interfaces/GlobalConfig.interface';
import { useTranslation } from 'react-i18next';
import { useQuantityInput } from '../hooks';

interface ReturnQuantityInputProps {
  value: number;
  lineItemQuantity: number;
  onChange: (value: number) => void;
}

export const ReturnQuantityInput = ({
  value,
  onChange,
  lineItemQuantity,
}: ReturnQuantityInputProps): JSX.Element => {
  const { t } = useTranslation();
  const { selectOptions } = useQuantityInput(lineItemQuantity);

  const handleOnSelect = (option: Option) => {
    onChange(option.value);
  };

  return (
    <Select
      value={value}
      options={selectOptions}
      onSelect={handleOnSelect}
      aria-label={t('LINE_ITEMS_QUANTITY')}
    />
  );
};
